const isProdOrStagingEnv =
    window.location.hostname.includes('mclass.amplify') ||
    window.location.hostname.includes('mclass.staging');

let SF_ORG_ID;
let botName;
const BOT_LABEL = 'MIAW_Chat_in_Amplify_Product';

if (isProdOrStagingEnv) {
    SF_ORG_ID = '00D300000000VGm';
    botName = 'ESWMIAWChatinAmplifyP1718752558633';
} else {
    SF_ORG_ID = '00DNq000000H6PB';
    botName = 'ESWMIAWChatinAmplifyP1713449167578';
}

const genScriptBaseUrl = subdomain =>
    isProdOrStagingEnv
        ? `https://amplify.my.${subdomain}.com`
        : `https://amplify--uat.sandbox.my.${subdomain}.com`;

const baseUrl = genScriptBaseUrl('site');

export default {
    BASE_URL: baseUrl,
    SCRIPT_SRC: `${baseUrl}/${botName}/assets/js/bootstrap.min.js`,
    BOT_ADDRESS: `${baseUrl}/${botName}`,
    SCRT_2_URL: genScriptBaseUrl('salesforce-scrt'),
    SF_ORG_ID,
    BOT_LABEL,
    EVENT_TYPES: {
        ON_READY: 'onEmbeddedMessagingReady',
        ON_TOKEN_EXPIRED: 'onEmbeddedMessagingIdentityTokenExpired',
    },
};
